// ── '회사 확인 필요' 표시 + [회사 정하기] (2026-10-19, 5단계 홍보물 5-6) ──────────────────
//   통합 홍보물 화면에는 회사값 없는 주문도 보인다(서버가 needs_company 로 알려 준다 — 사용자 결정 2: 짐작해서 넣지 않는다).
//   그 주문 상호 아래에 '회사 확인 필요'를 붙이고, 운영자·홍보물 관리 담당자에게는 [회사 정하기]를 보여 준다.
//   고르면 서버(PATCH {주문 주소}/:id/company)가 회사값 없는 주문일 때만 적고, 주문 이력·업무 기록을 남긴다.
//   본사·회사별 화면은 needs_company 를 받지 않아(본사는 받아도 정하기 불가) 표시만 하거나 아무것도 안 그린다.
import React, { createContext, useContext, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useToast } from '../../../components/Toast';
import { usePromoApi } from './promoApi';
import { companyColor } from '../integratedmenu/integratedFeatureMeta';
import { useCompanyNames } from '../adminlayout/useCompanyNames';

/** 화면 본체가 내려 준다: { companies: 고를 회사 코드들, canAssign: 정하기 가능, onAssigned: 다시 불러오기 } */
export const PromoScreenContext = createContext({ companies: [], canAssign: false, onAssigned: null });

const badge = {
  display: 'inline-block', marginTop: 3, padding: '1px 7px', borderRadius: 999, fontSize: 11, fontWeight: 700,
  background: 'var(--mm-tone-amber-bg, rgba(245,158,11,0.15))', color: 'var(--mm-tone-amber-text, #b45309)',
  border: '1px solid var(--mm-tone-amber-border, rgba(245,158,11,0.4))', whiteSpace: 'nowrap',
};
const linkBtn = { marginLeft: 6, border: 'none', background: 'none', padding: 0, fontSize: 11, fontWeight: 700, color: 'var(--accent, #2563eb)', cursor: 'pointer', textDecoration: 'underline' };
const chip = (on, code) => {
  const c = companyColor(code);
  return {
    height: 26, padding: '0 10px', borderRadius: 999, cursor: 'pointer', fontSize: 12, fontWeight: 700,
    border: `1.5px solid ${on ? c.bg : 'var(--border)'}`, background: on ? c.bg : 'var(--bg-card)', color: on ? c.fg : 'var(--text-sub)',
  };
};
const smallBtn = { height: 26, padding: '0 10px', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer', border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text)' };

export function PromoCompanyAssign({ order }) {
  const { companies, canAssign, onAssigned } = useContext(PromoScreenContext);
  const api = usePromoApi();
  const { showToast } = useToast();
  const nameOf = useCompanyNames();
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState('');
  const [saving, setSaving] = useState(false);
  if (!order?.needs_company) return null;

  async function save() {
    if (!picked) { showToast('회사를 골라 주세요.', 'error'); return; }
    setSaving(true);
    const res = await apiClient.patch(`${api.orders}/${order.id}/company`, { company_code: picked });
    setSaving(false);
    if (!res.ok) { showToast(res.data?.message || '회사를 정하지 못했습니다.', 'error'); return; }
    showToast(`${order.company_name || '주문'} — ${nameOf(picked)} 주문으로 정했습니다.`, 'success');
    setOpen(false);
    if (onAssigned) await onAssigned();
  }

  return (
    <div data-promo-needs-company={order.id}>
      <span style={badge}>회사 확인 필요</span>
      {canAssign && !open && <button type="button" style={linkBtn} onClick={() => setOpen(true)}>회사 정하기</button>}
      {canAssign && open && (
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginTop: 6 }}>
          {(companies || []).map((code) => (
            <button key={code} type="button" style={chip(picked === code, code)} aria-pressed={picked === code} onClick={() => setPicked(code)}>
              {nameOf(code)}
            </button>
          ))}
          <button type="button" style={{ ...smallBtn, background: 'var(--mm-tone-blue-solid-bg)', color: 'var(--mm-tone-blue-solid-text)', border: 'none' }} disabled={saving} onClick={save}>
            {saving ? '저장 중…' : '정하기'}
          </button>
          <button type="button" style={smallBtn} disabled={saving} onClick={() => { setOpen(false); setPicked(''); }}>취소</button>
        </div>
      )}
    </div>
  );
}
